// extracted by mini-css-extract-plugin
export default {"infoContainer":"styles_infoContainer__Pzp9s","title":"styles_title__1IqWu","paragraph":"styles_paragraph__mgN20"};